import {observer} from 'mobx-react-lite';
import {useStore} from '@/store/root-store';
import styled from 'styled-components';
import {TermsDropdowns} from './TermsDropdowns';
// import {NextImg} from '@/utils/nextImg';


export const FocusTermsTab = observer(() => {
  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');


  return currentPage?.analytics?.includedTerms?.length || currentPage?.analytics?.includeMoreTerms?.length || currentPage?.analytics?.includeLessTerms?.length ? (
    <TermsDropdowns />) : <EmptyDataBox>
    {/* <div className={localStyles.emptyImg}><NextImg src='/img/icon/Vector-checked.svg' /></div> */}
    <span style={{color: '#a3a4a4'}}>{currentPage?.isAnalyzing ? 'Loading Focus Terms...' : <span style={{color: '#a3a4a4'}}>Please add Target Keywords to view Focus Terms or
      <span style={{color: 'rgb(52, 174, 243)', cursor: 'pointer'}} onClick={() => currentPage.setShowAddFocusTermModal(true)}> add terms manually</span></span>}</span>
  </EmptyDataBox>;
});

const EmptyDataBox = styled.div`
  background: #2d2f34;
  border-radius: 5px;
  box-shadow: 0 4px 21px rgba(0, 0, 0, 0.02);
  display: flex;
  padding: 12px 15px;

  .emptyImg {
    display: flex;
    justify-content: center;
  }

  .emptyDataTitle {
    color: #a3a4a4;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    margin-left: 17px;
  }
`;

